// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"AU4_thecomp__JR4N4"};